import React from 'react';
import { number, bool } from 'prop-types';
import classNames from 'classnames/bind';
import styles from './estimated-total.module.scss';

const cx = classNames.bind(styles);

const EstimatedTotal = ({ total, isMobile, coverage }) => (
  <div>
    {!!total && !!coverage
        && (
          <section className={cx('estimated-total')}>
            <h3 className={cx('estimated-total__heading u__bold')}>Estimated Total:
              <span className={cx('estimated-total__price')}>${total}</span>
            </h3>
            <p className={cx('estimated-total__price-includes')}>
              Price includes <strong>{coverage} sq ft.*</strong>,
              full installation of carpet, carpet pad and any additional installation materials.
            </p>
            {isMobile
            && (
              <p className={cx('estimated-total__price-includes u__legal')}>
                *Pricing is an estimate only. Final price is determined by
                the results of the measure and the final materials selection.
                Additional charges may apply if the existing flooring is
                removed due to unforeseeable condition (e.g damage or deterioration).
                Please use this estimate as a guide to determine if the project is
                within your price range.
              </p>
            )}
          </section>
        )}
  </div>
);

EstimatedTotal.propTypes = {
  total: number,
  isMobile: bool.isRequired,
  coverage: number
};

EstimatedTotal.defaultProps = {
  total: 0,
  coverage: 0
};

export { EstimatedTotal };